// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iKyL","input":"styles_input__8vD8T"};